<template>
	<div>
		<!-- ================= ARRIVAL - APPROVE ================= -->
		<pui-modal-dialog-form
			:titleText="$t('modal.anchorageoperations.approveArrivalHm')"
			modelName="anchorageoperations"
			dialogName="anchorageoperationsApproveArrivalHm"
			v-model="modalData"
			:onOk="onOkApproveArrivalHm"
		>
			<template slot="message">
				<v-layout wrap class="justify-center">
					<v-flex xs12>
						<pui-text-area
							id="observations-arrival-approve-hm"
							v-model="modalData.observations"
							:label="$t('modal.observations')"
							toplabel
							maxlength="512"
						/>
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>

		<pui-modal-dialog-form
			:titleText="$t('modal.anchorageoperations.approveArrivalCuof')"
			modelName="anchorageoperations"
			dialogName="anchorageoperationsApproveArrivalCuof"
			v-model="modalData"
			:onOk="onOkApproveArrivalCuof"
		>
			<template slot="message">
				<v-layout wrap class="justify-center">
					<v-flex xs12>
						<pui-text-area
							id="observations-arrival-approve-cuof"
							v-model="modalData.observations"
							:label="$t('modal.observations')"
							toplabel
							maxlength="512"
						/>
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>

		<pui-modal-dialog-form
			:titleText="$t('modal.anchorageoperations.approveArrivalPp')"
			modelName="anchorageoperations"
			dialogName="anchorageoperationsApproveArrivalPp"
			v-model="modalData"
			:onOk="onOkApproveArrivalPp"
		>
			<template slot="message">
				<v-layout wrap class="justify-center">
					<v-flex xs12>
						<pui-text-area
							id="observations-arrival-approve-pp"
							v-model="modalData.observations"
							:label="$t('modal.observations')"
							toplabel
							maxlength="512"
						/>
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>

		<!-- ================= ARRIVAL - DENY ================= -->

		<pui-modal-dialog-form
			:titleText="$t('modal.anchorageoperations.denyArrivalHm')"
			modelName="anchorageoperations"
			dialogName="anchorageoperationsDenyArrivalHm"
			v-model="modalData"
			:onOk="onOkDenyArrivalHm"
		>
			<template slot="message">
				<v-layout wrap class="justify-center">
					<v-flex xs12>
						<pui-text-area
							id="observations-arrival-deny-hm"
							v-model="modalData.observations"
							:label="$t('modal.observations')"
							toplabel
							maxlength="512"
						/>
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>

		<pui-modal-dialog-form
			:titleText="$t('modal.anchorageoperations.denyArrivalCuof')"
			modelName="anchorageoperations"
			dialogName="anchorageoperationsDenyArrivalCuof"
			v-model="modalData"
			:onOk="onOkDenyArrivalCuof"
		>
			<template slot="message">
				<v-layout wrap class="justify-center">
					<v-flex xs12>
						<pui-text-area
							id="observations-arrival-deny-cuof"
							v-model="modalData.observations"
							:label="$t('modal.observations')"
							toplabel
							maxlength="512"
						/>
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>

		<pui-modal-dialog-form
			:titleText="$t('modal.anchorageoperations.denyArrivalPp')"
			modelName="anchorageoperations"
			dialogName="anchorageoperationsDenyArrivalPp"
			v-model="modalData"
			:onOk="onOkDenyArrivalPp"
		>
			<template slot="message">
				<v-layout wrap class="justify-center">
					<v-flex xs12>
						<pui-text-area
							id="observations-arrival-deny-pp"
							v-model="modalData.observations"
							:label="$t('anchorageoperations.observationsArrival')"
							toplabel
							maxlength="512"
						/>
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>
		<!-- ================= DEPARTURE - APPROVE ================= -->

		<pui-modal-dialog-form
			:titleText="$t('modal.anchorageoperations.approveDepartureHm')"
			modelName="anchorageoperations"
			dialogName="anchorageoperationsApproveDepartureHm"
			v-model="modalData"
			:onOk="onOkApproveDepartureHm"
		>
			<template slot="message">
				<v-layout wrap class="justify-center">
					<v-flex xs12>
						<pui-text-area
							id="observations-departure-approve-hm"
							v-model="modalData.observations"
							:label="$t('anchorageoperations.observationsDeparture')"
							toplabel
							maxlength="512"
						/>
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>

		<pui-modal-dialog-form
			:titleText="$t('modal.anchorageoperations.approveDepartureCuof')"
			modelName="anchorageoperations"
			dialogName="anchorageoperationsApproveDepartureCuof"
			v-model="modalData"
			:onOk="onOkApproveDepartureCuof"
		>
			<template slot="message">
				<v-layout wrap class="justify-center">
					<v-flex xs12>
						<pui-text-area
							id="observations-departure-approve-cuof"
							v-model="modalData.observations"
							:label="$t('modal.observations')"
							toplabel
							maxlength="512"
						/>
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>

		<pui-modal-dialog-form
			:titleText="$t('modal.anchorageoperations.approveDeparturePp')"
			modelName="anchorageoperations"
			dialogName="anchorageoperationsApproveDeparturePp"
			v-model="modalData"
			:onOk="onOkApproveDeparturePp"
		>
			<template slot="message">
				<v-layout wrap class="justify-center">
					<v-flex xs12>
						<pui-text-area
							id="observations-departure-approve-pp"
							v-model="modalData.observations"
							:label="$t('modal.observations')"
							toplabel
							maxlength="512"
						/>
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>

		<!-- ================= DEPARTURE - DENY ================= -->

		<pui-modal-dialog-form
			:titleText="$t('modal.anchorageoperations.denyDepartureHm')"
			modelName="anchorageoperations"
			dialogName="anchorageoperationsDenyDepartureHm"
			v-model="modalData"
			:onOk="onOkDenyDepartureHm"
		>
			<template slot="message">
				<v-layout wrap class="justify-center">
					<v-flex xs12>
						<pui-text-area
							id="observations-departure-deny-hm"
							v-model="modalData.observations"
							:label="$t('modal.observations')"
							toplabel
							maxlength="512"
						/>
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>

		<pui-modal-dialog-form
			:titleText="$t('modal.anchorageoperations.denyDepartureCuof')"
			modelName="anchorageoperations"
			dialogName="anchorageoperationsDenyDepartureCuof"
			v-model="modalData"
			:onOk="onOkDenyDepartureCuof"
		>
			<template slot="message">
				<v-layout wrap class="justify-center">
					<v-flex xs12>
						<pui-text-area
							id="observations-departure-deny-cuof"
							v-model="modalData.observations"
							:label="$t('modal.observations')"
							toplabel
							maxlength="512"
						/>
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>

		<pui-modal-dialog-form
			:titleText="$t('modal.anchorageoperations.denyDeparturePp')"
			modelName="anchorageoperations"
			dialogName="anchorageoperationsDenyDeparturePp"
			v-model="modalData"
			:onOk="onOkDenyDeparturePp"
		>
			<template slot="message">
				<v-layout wrap class="justify-center">
					<v-flex xs12>
						<pui-text-area
							id="observations-departure-deny-pp"
							v-model="modalData.observations"
							:label="$t('modal.observations')"
							toplabel
							maxlength="512"
						/>
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>
	</div>
</template>

<script>
export default {
	name: 'AnchorageoperationsModals',
	data() {
		return {
			model: 'anchorageoperations',
			modelName: 'anchorageoperations',
			modalData: {},
			dialogNameAnchorageoperationsApproveArrivalHm: 'anchorageoperationsApproveArrivalHm'
		};
	},
	created() {
		// Arrival
		this.$puiEvents.$on('pui-modalDialogForm-anchorageoperationsApproveArrival-' + this.modelName + '-show', (data) => {
			if (data) {
				this.modalData = Object.assign({}, data);
			}
		});
		this.$puiEvents.$on('pui-modalDialogForm-anchorageoperationsApproveArrivalHm-' + this.modelName + '-show', (data) => {
			if (data) {
				this.modalData = Object.assign({}, data);
			}
		});
		this.$puiEvents.$on('pui-modalDialogForm-anchorageoperationsApproveArrivalCuof-' + this.modelName + '-show', (data) => {
			if (data) {
				this.modalData = Object.assign({}, data);
			}
		});
		this.$puiEvents.$on('pui-modalDialogForm-anchorageoperationsApproveArrivalPp-' + this.modelName + '-show', (data) => {
			if (data) {
				this.modalData = Object.assign({}, data);
			}
		});

		// Deny Arrival
		this.$puiEvents.$on('pui-modalDialogForm-anchorageoperationsDenyArrival-' + this.modelName + '-show', (data) => {
			if (data) {
				this.modalData = Object.assign({}, data);
			}
		});
		this.$puiEvents.$on('pui-modalDialogForm-anchorageoperationsDenyArrivalHm-' + this.modelName + '-show', (data) => {
			if (data) {
				this.modalData = Object.assign({}, data);
			}
		});
		this.$puiEvents.$on('pui-modalDialogForm-anchorageoperationsDenyArrivalCuof-' + this.modelName + '-show', (data) => {
			if (data) {
				this.modalData = Object.assign({}, data);
			}
		});
		this.$puiEvents.$on('pui-modalDialogForm-anchorageoperationsDenyArrivalPp-' + this.modelName + '-show', (data) => {
			if (data) {
				this.modalData = Object.assign({}, data);
			}
		});

		// Departure
		this.$puiEvents.$on('pui-modalDialogForm-anchorageoperationsApproveDeparture-' + this.modelName + '-show', (data) => {
			if (data) {
				this.modalData = Object.assign({}, data);
			}
		});
		this.$puiEvents.$on('pui-modalDialogForm-anchorageoperationsApproveDepartureHm-' + this.modelName + '-show', (data) => {
			if (data) {
				this.modalData = Object.assign({}, data);
			}
		});
		this.$puiEvents.$on('pui-modalDialogForm-anchorageoperationsApproveDepartureCuof-' + this.modelName + '-show', (data) => {
			if (data) {
				this.modalData = Object.assign({}, data);
			}
		});
		this.$puiEvents.$on('pui-modalDialogForm-anchorageoperationsApproveDeparturePp-' + this.modelName + '-show', (data) => {
			if (data) {
				this.modalData = Object.assign({}, data);
			}
		});

		// Deny Departure
		this.$puiEvents.$on('pui-modalDialogForm-anchorageoperationsDenyDeparture-' + this.modelName + '-show', (data) => {
			if (data) {
				this.modalData = Object.assign({}, data);
			}
		});
		this.$puiEvents.$on('pui-modalDialogForm-anchorageoperationsDenyDepartureHm-' + this.modelName + '-show', (data) => {
			if (data) {
				this.modalData = Object.assign({}, data);
			}
		});
		this.$puiEvents.$on('pui-modalDialogForm-anchorageoperationsDenyDepartureCuof-' + this.modelName + '-show', (data) => {
			if (data) {
				this.modalData = Object.assign({}, data);
			}
		});
		this.$puiEvents.$on('pui-modalDialogForm-anchorageoperationsDenyDeparturePp-' + this.modelName + '-show', (data) => {
			if (data) {
				this.modalData = Object.assign({}, data);
			}
		});
	},
	beforeDestroy() {
		this.$puiEvents.$off('pui-modalDialogForm-anchorageoperationsApproveArrival-' + this.modelName + '-show');
		this.$puiEvents.$off('pui-modalDialogForm-anchorageoperationsApproveArrivalHm-' + this.modelName + '-show');
		this.$puiEvents.$off('pui-modalDialogForm-anchorageoperationsApproveArrivalCuof-' + this.modelName + '-show');
		this.$puiEvents.$off('pui-modalDialogForm-anchorageoperationsApproveArrivalPp-' + this.modelName + '-show');

		this.$puiEvents.$off('pui-modalDialogForm-anchorageoperationsDenyArrival-' + this.modelName + '-show');
		this.$puiEvents.$off('pui-modalDialogForm-anchorageoperationsDenyArrivalHm-' + this.modelName + '-show');
		this.$puiEvents.$off('pui-modalDialogForm-anchorageoperationsDenyArrivalCuof-' + this.modelName + '-show');
		this.$puiEvents.$off('pui-modalDialogForm-anchorageoperationsDenyArrivalPp-' + this.modelName + '-show');

		this.$puiEvents.$off('pui-modalDialogForm-anchorageoperationsApproveDeparture-' + this.modelName + '-show');
		this.$puiEvents.$off('pui-modalDialogForm-anchorageoperationsApproveDepartureHm-' + this.modelName + '-show');
		this.$puiEvents.$off('pui-modalDialogForm-anchorageoperationsApproveDepartureCuof-' + this.modelName + '-show');
		this.$puiEvents.$off('pui-modalDialogForm-anchorageoperationsApproveDeparturePp-' + this.modelName + '-show');

		this.$puiEvents.$off('pui-modalDialogForm-anchorageoperationsDenyDeparture-' + this.modelName + '-show');
		this.$puiEvents.$off('pui-modalDialogForm-anchorageoperationsDenyDepartureHm-' + this.modelName + '-show');
		this.$puiEvents.$off('pui-modalDialogForm-anchorageoperationsDenyDepartureCuof-' + this.modelName + '-show');
		this.$puiEvents.$off('pui-modalDialogForm-anchorageoperationsDenyDeparturePp-' + this.modelName + '-show');
	},
	methods: {
		// APPROVE ARRIVAL
		onOkApproveArrivalHm(modalData) {
			return this.callApproval('approveArrivalHm', modalData, true);
		},

		onOkApproveArrivalCuof(modalData) {
			return this.callApproval('approveArrivalCuof', modalData, true);
		},

		onOkApproveArrivalPp(modalData) {
			return this.callApproval('approveArrivalPp', modalData, true);
		},

		// DENY ARRIVAL
		onOkDenyArrivalHm(modalData) {
			return this.callApproval('approveArrivalHm', modalData, false);
		},

		onOkDenyArrivalCuof(modalData) {
			return this.callApproval('approveArrivalCuof', modalData, false);
		},

		onOkDenyArrivalPp(modalData) {
			return this.callApproval('approveArrivalPp', modalData, false);
		},

		//APPROVE DEPARTURE
		onOkApproveDepartureHm(modalData) {
			return this.callApproval('approveDepartureHm', modalData, true);
		},

		onOkApproveDepartureCuof(modalData) {
			return this.callApproval('approveDepartureCuof', modalData, true);
		},

		onOkApproveDeparturePp(modalData) {
			return this.callApproval('approveDeparturePp', modalData, true);
		},

		//DENY DEPARTURE
		onOkDenyDepartureHm(modalData) {
			return this.callApproval('approveDepartureHm', modalData, false);
		},

		onOkDenyDepartureCuof(modalData) {
			return this.callApproval('approveDepartureCuof', modalData, false);
		},

		onOkDenyDeparturePp(modalData) {
			return this.callApproval('approveDeparturePp', modalData, false);
		},

		// Aprueba/Deniega salida (departure) para cualquier rol
		runApproval(modalData, approved, actionType) {
			let urlKey = '';
			if (actionType === 'approveDeparture') {
				switch (modalData.approvalRole) {
					case 'Hm':
						urlKey = 'approveDepartureHm';
						break;
					case 'Cuof':
						urlKey = 'approveDepartureCuof';
						break;
					case 'Pp':
						urlKey = 'approveDeparturePp';
						break;
					default:
						console.error('Rol no reconocido para departure:', modalData.approvalRole);
						return Promise.resolve(false);
				}
			}
			return this.callApproval(urlKey, modalData, approved);
		},
		// Deniega salida
		onOkDenyDeparture(modalData) {
			return this.runApproval(modalData, false, 'approveDeparture');
		},

		// Llama al endpoint correcto según el rol y acción
		callApproval(urlKey, modalData, approved) {
			const model = this.$store.getters.getModelByName(this.modelName);
			const urlController = model.url[urlKey];

			if (!urlController) {
				console.error('URL no definida:', urlKey);
				return Promise.resolve(false);
			}

			const params = {
				anchorageoperationid: modalData.anchorageoperationid,
				approved,
				observations: modalData.observations
			};

			const title = this.$puiI18n.t(approved ? 'action.approve' : 'action.reject');

			return new Promise((resolve) => {
				this.$puiRequests.getRequest(
					urlController,
					params,
					() => {
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
						this.$puiEvents.$emit('refreshForm-action-running-ended-' + this.modelName);
						localStorage.setItem('tabFromAction', 'anchorageoperations');
						this.$puiEvents.$emit('refreshAnchorageStatus-portcalls');
						this.$puiNotify.success(this.$puiI18n.t('puiaction.notifySuccess'), title);
						resolve(true);
					},
					(e) => {
						const msg = e?.response?.data?.message || this.$puiI18n.t('puiaction.notifyError');
						this.$puiNotify.error(msg, title);
						resolve(false);
					}
				);
			});
		}
	}
};
</script>
